import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pc_modal_remember_1.png'


const _withScopeId = n => (_pushScopeId("data-v-4e0ef55a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_remember_one",
  ref: "modalRememberOne",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-remember-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-remember-container-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = { class: "modal-remember-container-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "G’hèt vist che robe?? 😎", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, [
  /*#__PURE__*/_createTextVNode("Belle, eh?? Però il tuo carrello è ancora tutto"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("vuoto…non farlo piangere, poverino!")
], -1))
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "close" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-pc btn-pc-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
                onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
              }, "Merchandise", 32)
            ])
          ]),
          _hoisted_10
        ])
      ])
    ])
  ], 512))
}